import { B2_FORM_INIT_VALUES as B2_FORM_INIT_VALUES_SHARED } from 'shared'

export const B2_FORM_INIT_VALUES = B2_FORM_INIT_VALUES_SHARED
